import ServicePageTemplate from "@/components/ServicePageTemplate";
import { Share2 } from "lucide-react";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function SocialMedia() {
  usePageMeta({
    title: "ניהול סושיאל: לבנות קהילה ולהגדיל את המכירות במדיה החברתית | upsite",
    description: "הפכו את הרשתות החברתיות למכונת מכירות. ניהול סושיאל, קהילות, יצירת תוכן אנושי ובניית נוכחות חזקה שיוצרת אמון מול הלקוחות. בואו נספר את הסיפור שלכם בדיגיטל",
  });

  return (
    <ServicePageTemplate
      icon={Share2}
      title="ניהול סושיאל מקצועי"
      subtitle="ניהול סושיאל"
      description="ניהול תוכן ונוכחות ברשתות החברתיות שמחזק את המותג, מגדיל מעורבות ומייצר לידים. אנחנו יודעים איך לספר את הסיפור שלכם."
      image="/images/services/social-media.jpeg"
      benefits={[
        "בניית אסטרטגיית תוכן לרשתות החברתיות",
        "יצירת תוכן ויזואלי וטקסטואלי איכותי",
        "ניהול קהילה ומעורבות עם עוקבים",
        "דיווחים וניתוח ביצועים",
        "התאמה לטרנדים ועדכוני פלטפורמות",
        "שילוב עם אסטרטגיית השיווק הכוללת",
      ]}
      processSteps={[
        { title: "אפיון ואסטרטגיה", desc: "הבנת המותג, קהל היעד ובניית אסטרטגיית תוכן." },
        { title: "יצירת תוכן", desc: "הפקת תוכן ויזואלי וטקסטואלי שמתאים לכל פלטפורמה." },
        { title: "פרסום וניהול", desc: "פרסום תוכן בזמנים האופטימליים וניהול אינטראקציות." },
        { title: "ניתוח ושיפור", desc: "מדידת ביצועים, הפקת תובנות ושיפור מתמיד." },
      ]}
    />
  );
}
